/**
 * OwnerModuleCard - Reusable module card component for consistent page structure
 * Matches Calendar page polish pattern: unified card with header + body
 */
import React from 'react';

export default function OwnerModuleCard({ 
  title, 
  subtitle, 
  headerActions, 
  children,
  className = '',
  style = {},
  id,
  headerSticky = false,
  headerStickyTop
}) {
  const cardStyle = { ...style };
  delete cardStyle.headerSticky;
  delete cardStyle.headerStickyTop;
  
  return (
    <div 
      id={id}
      className={`owner-section-panel ${className}`}
      style={{
        ...cardStyle,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0, // Allow flex child to shrink
      }}
    >
      {(title || headerActions) && (
        <div 
          className="owner-section-panel-header"
          style={headerSticky ? {
            position: 'sticky',
            top: headerStickyTop || 'calc(var(--owner-top-nav-height, 52px) + var(--owner-sticky-gap, 12px))',
            zIndex: 9, // Above table content but below global nav
            backgroundColor: 'var(--owner-card-bg)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
          } : undefined}
        >
          <div style={styles.headerContent}>
            {title && (
              <h3 className="owner-section-panel-title">{title}</h3>
            )}
            {subtitle && (
              <p style={styles.subtitle}>{subtitle}</p>
            )}
          </div>
          {headerActions && (
            <div style={styles.headerActions}>
              {headerActions}
            </div>
          )}
        </div>
      )}
      <div style={styles.body}>
        {children}
      </div>
    </div>
  );
}

const styles = {
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-1)',
    flex: 1,
  },
  subtitle: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-text-secondary)',
    margin: 0,
    fontWeight: 'var(--font-weight-normal)',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--spacing-2)',
    flexShrink: 0,
  },
  body: {
    minWidth: 0, /* Prevent overflow */
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0, /* Allow flex child to shrink below content size */
  },
};
